import { useContextState } from "../../../../../../hooks/theme"

const useFilterHeaderStyles = () => {
    const { colors } = useContextState()
    return {
        containerIcons: {
            display: 'flex',
            alignItems: 'center',
            gap: '20px',
            flexWrap: 'nowrap',
            minWidth: 'fit-content'
        },
        badge: (payload?: {}) => ({
            '& .MuiBadge-badge': {
                top: 0,
                right: '0px',
                background: colors.mediumDark,
                color: colors.color5
            },
        }),
        header: {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        },
        refresh: {
            background: colors.orangeMedium,
            color: colors.color5,
            borderRadius: '5px',
            '&:hover': {
                background: `${colors.orangeMedium}ee`,
            },
            '& .MuiSvgIcon-root': {
                fontSize: '2.2rem',
            }
        },
        cleanText: {
            color: colors.color31,
            padding: '0px',
            minWidth: 'fit-content',
            whiteSpace: 'nowrap',
            flexShrink: 0
        },
        footerText: {
            fontSize: '14px',
            color: colors.color9,
            '& span': {
                color: colors.color13,
            },
        },
        filter: {
            background: colors.color12,
            color: colors.color5,
            borderRadius: '5px',
            '&:hover': {
                background: `${colors.color12}ee`,
            },
            '& .MuiSvgIcon-root': {
                fontSize: '2.2rem',
            }
        },
        containerModal: {
          padding: '50px',
          display: 'flex',
          flexWrap: 'wrap',
          gap: '20px',
        },
        headerModal: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%'
        },
        headerModalTitle: {
          fontSize: '22px',
          fontWeight: '500',
          color: colors.color9
        },
        close: {
          position: 'absolute',
          top: '10px',
          right: '10px',
          '&.MuiSvgIcon-root': {
            fontSize: '1rem'
          }
        },
        btnFilter: {
          fontSize: '16px',
          background: colors.color8,
          '&:hover': {
            background: `${colors.color8}ee`,
          },
          fontWeight: '500',
          padding: '5px 20px',
        },
    }
}

export { useFilterHeaderStyles }